import type { HTMLAttributes, ReactNode } from "react";

export interface CardProps extends Omit<HTMLAttributes<HTMLElement>, "title"> {
  title?: ReactNode;
  subtitle?: ReactNode;
  footer?: ReactNode;
  padding?: "none" | "sm" | "md" | "lg";
  children: ReactNode;
}

export function Card({
  title,
  subtitle,
  footer,
  padding = "md",
  children,
  className,
  ...rest
}: CardProps) {
  return (
    <section
      {...rest}
      className={["rp-card", `rp-card--pad-${padding}`, className]
        .filter(Boolean)
        .join(" ")}
    >
      {(title || subtitle) && (
        <header className="rp-card__header">
          {title && <h3 className="rp-card__title">{title}</h3>}
          {subtitle && <p className="rp-card__subtitle">{subtitle}</p>}
        </header>
      )}
      <div className="rp-card__body">{children}</div>
      {footer && <footer className="rp-card__footer">{footer}</footer>}
    </section>
  );
}
